import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import WistiaButton from '../components/wistia-button';
import { registerWidget } from '../components/contentful-views/sections';

/**
 * Maps to the Wistia Button content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/wistiaButton/fields}
 * @param {Object} props
 * @param {Object} model
 */
const WistiaButtonWidget = ({ model }) => <WistiaButton {...get(model, 'fields')} />;

WistiaButtonWidget.propTypes = {
  model: PropTypes.shape({}),
};

WistiaButtonWidget.defaultProps = {
  model: {},
};

registerWidget('wistiaButton', WistiaButtonWidget);

export default WistiaButtonWidget;
